module.exports = __webpack_public_path__ + "static/media/home-icon-active.578ea83e.svg";